import React from "react";
import _ from 'lodash'
import {Unit, Wing, UnitDark, WingDark, RoomDark, Room} from "../../constants/ProIcons"

export const selectedLevelType = (option, props) => {
    if (option) {
        return (
            <div className="country-item country-item-value">
                {_.isEqual(option.icon,"Wing")?<Wing/> 
                :_.isEqual(option.icon, "Unit")? <Unit/> 
                :_.isEqual(option.icon, "Room")? <Room/> 
                :<i className={option.icon} style={{ color: "#3F51B5" }}></i>  }                  
                <div style={{ display: "inline-block", marginLeft: "10px" }}>
                    {option.name}
                </div>
            </div>
        );
    }
    return <span>{props.placeholder}</span>;
};

export const levelOptionType = (option) => {
    return (
        <div className="country-item">
            {_.isEqual(option.icon,"Wing")?<WingDark/> 
            :_.isEqual(option.icon, "Unit")? <UnitDark/> 
            :_.isEqual(option.icon, "Room")? <RoomDark/> 
            : <i className={option.icon}></i>}               
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
                {option.name}
            </div>
        </div>
    );
};